export const ADD_CHART_REQUEST = " ADD_CHART_REQUEST";
export const ADD_CHART_SUCCESS = " ADD_CHART_SUCCESS";
export const ADD_CHART_FAILURE = " ADD_CHART_FAILURE";
